import {UserTracker} from "../index.js";

const eventDics = {
    "copy-invitation-link-click": "invite-employee:copy-invitation-link-click:click", // 초대장 링크 복사
    "email-invite-click": "invite-employee:email-invite-click:click", // 이메일 초대
    "google-invite-click": "invite-employee:google-invite-click:click", // 구글 연락처/워크스페이스 초대
    "excel-invite-click": "invite-employee:excel-invite-click:click", // 엑셀로 등록
}

export const InviteEmplUserTracker = () => {
    const Tracker = Object.create(UserTracker);
    Tracker.track = (eventName, value = null) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value, data: {}});
    }

    return Tracker;
}
